/**
 * 토스트(피드백 메시지) 전역 설정
 *
 * 호출부가 3개 프론트 합쳐 391곳이라 개별 수정 대신 전역에서 규칙을 잡는다.
 * - 모양·가시성은 index.css 의 `.ant-message-*` 규칙이 담당 (App.useApp() 컨텍스트 메시지까지 100% 적용)
 * - 여기서는 위치·중첩 상한·**종류별 표시 시간**만 정한다
 *
 * 표시 시간을 종류별로 두는 이유: 성공은 확인만 하면 되지만 오류는 읽고 조치해야 한다.
 * 기존에는 둘 다 3초라 오류 메시지를 놓치는 일이 있었다.
 */
import { message } from 'antd';

/** 종류별 기본 표시 시간(초) */
export const TOAST_DURATION = {
  success: 2.6,
  info: 3,
  warning: 4.5,
  error: 5,
} as const;

/** 헤더 아래에 뜨도록 — 전역검색/알림벨을 가리지 않는다 */
export const TOAST_TOP = 68;

message.config({ top: TOAST_TOP, duration: 3, maxCount: 3 });

/**
 * 호출부(391곳)를 고치지 않고 종류별 기본 시간을 적용하기 위한 얇은 래핑.
 * antd 정적 API 모양 `message.success(content, duration?, onClose?)` 에 의존하므로
 * 실패해도 앱이 죽지 않게 감싼다 — 실패 시 antd 기본 duration 으로 동작할 뿐이다.
 */
try {
  (Object.keys(TOAST_DURATION) as Array<keyof typeof TOAST_DURATION>).forEach((type) => {
    const orig = (message as any)[type];
    if (typeof orig !== 'function') return;
    (message as any)[type] = (content: any, duration?: any, onClose?: any) => {
      // ArgsProps 객체 형태({ content, duration, ... })는 그대로 넘긴다
      if (content && typeof content === 'object' && 'content' in content) {
        return orig(content, duration, onClose);
      }
      // message.success(content, onClose) 축약형 지원
      if (typeof duration === 'function') {
        onClose = duration;
        duration = undefined;
      }
      return orig(content, duration ?? TOAST_DURATION[type], onClose);
    };
  });
} catch {
  /* 래핑 실패 — antd 기본 duration 으로 동작 */
}
